export const SESSION_ACTIONS_TYPES = {
  SET_LOGGED_IN : "SET_LOGGED_IN",
  SSO_FAILED : "SSO_FAILED"
}

export const SESSION_ACTIONS = {
  SET_LOGGED_IN : (payload ?: string) => {
    return {
      type : SESSION_ACTIONS_TYPES.SET_LOGGED_IN,
      token : payload
    }
  },
  SSO_FAILED : (payload ?: string) => {
    return {
      type : SESSION_ACTIONS.SSO_FAILED,
      error : payload
    }
  }
}